var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { apolloClient } from '../ApolloClient';
import { LayerType, SpecialApprovedUse, SpecialSubCategory } from '../components/constants/ENUMS';
import { EXCHANGE_VARIABLES } from '../components/constants/EXCHANGE_VARIABLES';
import { COMPONENTLAYERTYPEAPPROVEDUSE_MAP, COMPONENTLAYERTYPESUBCATEGORY_MAP } from '../components/constants/LAYERTYPEAPPROVEDUSE_MAP';
import { AssemblyApiRoofTypeSearchDocument, AssemblyApiSearchDocument, Order_By } from '../models/GQLGeneratedModels';
import { isRNDM } from '../utils/RNDMUtilities';
import { hasFullAccess, permissionEnums } from '../utils/userRoles';
export var ComparisonOperator = /*#__PURE__*/ function (ComparisonOperator) { ComparisonOperator[ComparisonOperator["EqualTo"] = 0] = "EqualTo"; ComparisonOperator[ComparisonOperator["NotEqualTo"] = 1] = "NotEqualTo"; ComparisonOperator[ComparisonOperator["GreaterThan"] = 2] = "GreaterThan"; ComparisonOperator[ComparisonOperator["GreaterThanOrEqual"] = 3] = "GreaterThanOrEqual"; ComparisonOperator[ComparisonOperator["LessThan"] = 4] = "LessThan"; ComparisonOperator[ComparisonOperator["LessThanOrEqual"] = 5] = "LessThanOrEqual"; return ComparisonOperator; }({});
export var AttributeType = /*#__PURE__*/ function (AttributeType) { AttributeType[AttributeType["Boolean"] = 1] = "Boolean"; AttributeType[AttributeType["CodeTable"] = 2] = "CodeTable"; AttributeType[AttributeType["Measurement"] = 3] = "Measurement"; AttributeType[AttributeType["Text"] = 4] = "Text"; AttributeType[AttributeType["Multivalue"] = 5] = "Multivalue"; return AttributeType; }({});
export var SortOperator = /*#__PURE__*/ function (SortOperator) { SortOperator[SortOperator["Ascending"] = 0] = "Ascending"; SortOperator[SortOperator["Descending"] = 1] = "Descending"; return SortOperator; }({});
function getSubCategoryId(arrayVariableAssignments, section) {
    var subCategoryId = 0; // Get subCategoryId from variable ManufacturedProduct_SubcategoryId
    var dataSubCategoryId = arrayVariableAssignments.find(function (data) { return data.variableId === 'ManufacturedProduct_SubcategoryId'; });
    if (dataSubCategoryId === undefined) {
        subCategoryId = 0;
    }
    else {
        if (dataSubCategoryId.value) {
            subCategoryId = parseInt(dataSubCategoryId.value.toString());
            subCategoryId = isNaN(subCategoryId) ? 0 : subCategoryId;
        }
    }
    if (subCategoryId === 0 && section) {
        var _section$variables;
        var itemSubCategory = (_section$variables = section.variables) === null || _section$variables === void 0 ? void 0 : _section$variables.find(function (item) { return item.id === 'ManufacturedProduct_SubcategoryId'; });
        if (itemSubCategory && itemSubCategory.values)
            for (var i = 0; i < itemSubCategory.values.length; i++) {
                if (itemSubCategory.values[i].hasOwnProperty('assigned') && itemSubCategory.values[i]['assigned'] === 'byRule') {
                    var _value;
                    var temp = (_value = itemSubCategory.values[i].value) === null || _value === void 0 ? void 0 : _value.toString();
                    if (temp) {
                        subCategoryId = parseInt(temp);
                        subCategoryId = isNaN(subCategoryId) ? 0 : subCategoryId;
                    }
                    break;
                }
            }
    }
    return subCategoryId;
}
function getApprovedUseId(arrayVariableAssignments, section) {
    var approvedUseId = 0; // Get approvedUseId from variable CApprovedUse_ApprovedUseId
    var dataApprovedUseId = arrayVariableAssignments.find(function (data) { return data.variableId === 'CApprovedUse_ApprovedUseId'; });
    if (dataApprovedUseId === undefined) {
        approvedUseId = 0;
    }
    else {
        if (dataApprovedUseId.value) {
            approvedUseId = parseInt(dataApprovedUseId.value.toString());
            approvedUseId = isNaN(approvedUseId) ? 0 : approvedUseId;
        }
    }
    if (approvedUseId === 0 && section) {
        var _section$variables2;
        var itemApprovedUse = (_section$variables2 = section.variables) === null || _section$variables2 === void 0 ? void 0 : _section$variables2.find(function (item) { return item.id === 'CApprovedUse_ApprovedUseId'; });
        if (itemApprovedUse && itemApprovedUse.values)
            for (var i = 0; i < itemApprovedUse.values.length; i++) {
                if (itemApprovedUse.values[i].hasOwnProperty('assigned') && itemApprovedUse.values[i]['assigned'] === 'byRule') {
                    var _value2;
                    var temp = (_value2 = itemApprovedUse.values[i].value) === null || _value2 === void 0 ? void 0 : _value2.toString();
                    if (temp) {
                        approvedUseId = parseInt(temp);
                        approvedUseId = isNaN(approvedUseId) ? 0 : approvedUseId;
                    }
                    break;
                }
            }
    }
    return approvedUseId;
}
export var getAssembliesByActionAPI = function (assemblySearchCriteria) { return __awaiter(void 0, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, apolloClient.query({ query: AssemblyApiSearchDocument, variables: { assemblySearchCriteria: assemblySearchCriteria } })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}); };
export var getAssembliesRoofTypeByActionAPI = function (assemblySearchCriteria) { return __awaiter(void 0, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, apolloClient.query({ query: AssemblyApiRoofTypeSearchDocument, variables: { assemblySearchCriteria: assemblySearchCriteria } })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}); };
export var testSearchAssembliesAPI = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _result$data$navassem, assemblySearchCriteria, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                assemblySearchCriteria = { assemblyCriteria: { AssemblyTypeId: 3, DeckTypeId: 7, HailRatingId: 1, IntFireRatingId: 2, ExtFireRatingId: 1 }, LayerCriteria: [{ layerTypeId: 39, approvedUseId: 0, subCategoryId: 0, attributes: [], manufacturerIds: [], componentIds: [], layerNum: 1, fromlayerNum: 0, tolayerNum: 0, selfSecurement: null }, { layerTypeId: 22, approvedUseId: 5, subCategoryId: 21, attributes: [{ attributeName: 'ReinforcementId', attributeType: 2, attributeValue: '6', comparisonOperator: 0 }, { attributeName: 'Width', attributeType: 3, attributeValue: '914.4', comparisonOperator: 0 }], manufacturerIds: [532], componentIds: [], layerNum: 2, fromlayerNum: 0, tolayerNum: 0, selfSecurement: null }, { layerTypeId: 41, approvedUseId: 29, subCategoryId: 0, attributes: [{ attributeName: 'SecurementMaterialId', attributeType: 2, attributeValue: '1', comparisonOperator: 0 }], manufacturerIds: [], componentIds: [], layerNum: 3, fromlayerNum: 2, tolayerNum: 0, selfSecurement: null }, { layerTypeId: 25, approvedUseId: 0, subCategoryId: 0, attributes: [], manufacturerIds: [], componentIds: [], layerNum: 4, fromlayerNum: 0, tolayerNum: 0, selfSecurement: null }, { layerTypeId: 35, approvedUseId: 0, subCategoryId: 0, attributes: [], manufacturerIds: [], componentIds: [], layerNum: 5, fromlayerNum: 0, tolayerNum: 0, selfSecurement: null }], rowsPerPage: 25, pageNumber: 1, sortColumn: 'NavAssemblyName', sortDirection: 0 };
                return [4 /*yield*/, getAssembliesByActionAPI(assemblySearchCriteria)];
            case 1:
                result = _a.sent();
                (_result$data$navassem = result.data.navassembly_api_search) === null || _result$data$navassem === void 0 ? void 0 : _result$data$navassem.map(function (navAssembly) { console.log(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.NavAssemblyName); });
                return [2 /*return*/];
        }
    });
}); };
export var testSearchAssembliesRoofTypeAPI = function () { return __awaiter(void 0, void 0, void 0, function () { var assemblySearchCriteria, result; return __generator(this, function (_a) {
    switch (_a.label) {
        case 0:
            assemblySearchCriteria = { assemblyCriteria: { AssemblyTypeId: 3 }, LayerCriteria: [{ layerTypeId: 22, approvedUseId: 5, layerNum: 1, fromlayerNum: 0, tolayerNum: 0, subCategoryId: 21, manufacturerIds: [532], componentIds: [], attributes: [{ attributeName: 'ReinforcementId', comparisonOperator: 0, attributeValue: '6', attributeType: 2 }, { attributeName: 'Width', comparisonOperator: 0, attributeValue: '914.4', attributeType: 3 }], selfSecurement: null }], rowsPerPage: 25, pageNumber: 1, sortColumn: 'NumOfAssembly', sortDirection: 0 };
            return [4 /*yield*/, getAssembliesRoofTypeByActionAPI(assemblySearchCriteria)];
        case 1:
            result = _a.sent();
            console.log(result.data.navassembly_api_rooftypesearch);
            return [2 /*return*/];
    }
}); }); };
export var checkIfAPISearchNecessary = function (layers, filters) {
    var needAPISearch = false; //TODO Determine needAPISearch value based on filters
    //Duplicate layers with different attributes
    //Mapped Securement layers (exclude unmapped securement layers?) with manufacturers/products?, subcategory, approved use, and attributes?
    //Self Securement
    var securementLayers = layers.filter(function (layer) { return layer.isSecurementLayer === true; });
    if (securementLayers.length > 0) {
        for (var index = 0; index < securementLayers.length; index++) { // For each securement layer we only need to check SubCategoryId and ApprovedUseId
            // Since valid securement attribute filters have to be based on a specific approved use
            var layerSubCategoryId = 0;
            var layerApprovedUseId = 0;
            var securementLayer = securementLayers[index];
            if (securementLayer.variableAssignments) {
                var arrayVariableAssignments = securementLayer.variableAssignments; // Get subCategoryId from variable ManufacturedProduct_SubcategoryId
                var dataSubCategoryId = arrayVariableAssignments.find(function (data) { return data.variableId === 'ManufacturedProduct_SubcategoryId'; });
                if (dataSubCategoryId === undefined) {
                    layerSubCategoryId = 0;
                }
                else {
                    if (dataSubCategoryId.value) {
                        var subCategoryId = parseInt(dataSubCategoryId.value.toString());
                        layerSubCategoryId = isNaN(subCategoryId) ? 0 : subCategoryId;
                    }
                } // Get approvedUseId from variable CApprovedUse_ApprovedUseId
                var dataApprovedUseId = arrayVariableAssignments.find(function (data) { return data.variableId === 'CApprovedUse_ApprovedUseId'; });
                if (dataApprovedUseId === undefined) {
                    layerApprovedUseId = 0;
                }
                else {
                    if (dataApprovedUseId.value) {
                        var approvedUseId = parseInt(dataApprovedUseId.value.toString());
                        layerApprovedUseId = isNaN(approvedUseId) ? 0 : approvedUseId;
                    }
                }
            }
            if (layerSubCategoryId > 0 || layerApprovedUseId > 0) {
                return true;
            }
        }
    }
    var componentLayers = layers.filter(function (layer) { return layer.isSecurementLayer === false; });
    if (componentLayers.find(function (layer) { return layer.hasSelfSecurement; }))
        return true;
    else {
        var arrayLayerTypeIds_1 = componentLayers.map(function (layer) { return layer.id; });
        var hasDuplicateLayers = arrayLayerTypeIds_1.some(function (layerTypeId, idx) { return arrayLayerTypeIds_1.indexOf(layerTypeId) != idx; });
        if (hasDuplicateLayers)
            return true;
    }
    return needAPISearch;
};
export var getConfigitCriteria = function (layers, variableAssignments, excludedLayerIds, manufacturerProduct, limit, offset, orderBy) { return { layers: layers.filter(function (data) { return !data.autoSelected; }).map(function (data) { return __assign(__assign({}, data), { section: undefined }); }), variableAssignments: variableAssignments.filter(function (data) { return data.value; }), excludedLayerIds: excludedLayerIds, manufacturerProduct: manufacturerProduct, limit: limit, offset: offset, orderBy: orderBy }; };
export var getAPISearchCriteriaBasedOnFilters = function (layers, filters, excludedLayerTypeIds, manufacturerProduct, limit, offset, orderBy) {
    var _filters$NavAssemblyN; // console.log('layers in API Search is ', layers);
    // console.log('filters in API Search is ', filters);
    // Set initialize assemblySearchCriteria
    var assemblySearchCriteria = { assemblyCriteria: {}, LayerCriteria: [], rowsPerPage: 25, pageNumber: 1, sortColumn: 'NavAssemblyName', sortDirection: 0 }; // For Assembly Number Search
    if (filters.NavAssemblyName && filters.NavAssemblyName._like) {
        var searchString = filters.NavAssemblyName._like.toString();
        if (searchString.length > 0 && searchString.slice(-1) === '%') {
            assemblySearchCriteria.assemblyCriteria.NavAssemblyName = searchString.substring(0, searchString.length - 1);
            if (isRNDM && hasFullAccess(permissionEnums.singleAssemblyRevision)) {
                assemblySearchCriteria.assemblyCriteria.StatusId = -1; // status -1 means search across all assemblies regardless of status, which is only for RNN private site assembly number search
            }
        }
    } // For AIM Number Search
    if ((_filters$NavAssemblyN = filters.NavAssemblyName) !== null && _filters$NavAssemblyN !== void 0 && _filters$NavAssemblyN._eq) {
        var searchString = filters.NavAssemblyName._eq.toString();
        if (searchString.length > 4 && searchString.startsWith('AIM_')) {
            assemblySearchCriteria.assemblyCriteria.AIMNumber = searchString.substring(4);
        }
    } // Roof Type
    if (filters.LayerConfigId && filters.LayerConfigId._eq) {
        assemblySearchCriteria.assemblyCriteria.LayerConfigId = parseInt(filters.LayerConfigId._eq.toString());
    } // Assembly Property Search Criteria
    // The following Assembly Property Search Criteria only involve of comparison operator _eq
    // Such criteria in filters has the format like AssemblyApplicationTypeId: {_eq: 1}
    if (filters.AssemblyApplicationTypeId && filters.AssemblyApplicationTypeId._eq) {
        assemblySearchCriteria.assemblyCriteria.AssemblyApplicationTypeId = parseInt(filters.AssemblyApplicationTypeId._eq.toString());
    }
    if (filters.AssemblyTypeId && filters.AssemblyTypeId._eq) {
        assemblySearchCriteria.assemblyCriteria.AssemblyTypeId = parseInt(filters.AssemblyTypeId._eq.toString());
    }
    if (filters.CoverSecurementMethodId && filters.CoverSecurementMethodId._eq) {
        assemblySearchCriteria.assemblyCriteria.CoverSecurementMethodId = parseInt(filters.CoverSecurementMethodId._eq.toString());
    }
    if (filters.DeckTypeId && filters.DeckTypeId._eq) {
        assemblySearchCriteria.assemblyCriteria.DeckTypeId = parseInt(filters.DeckTypeId._eq.toString());
    }
    if (filters.HailRatingId && filters.HailRatingId._eq) {
        assemblySearchCriteria.assemblyCriteria.HailRatingId = parseInt(filters.HailRatingId._eq.toString());
    }
    if (filters.IntFireRatingId && filters.IntFireRatingId._eq) {
        assemblySearchCriteria.assemblyCriteria.IntFireRatingId = parseInt(filters.IntFireRatingId._eq.toString());
    }
    if (filters.ExtFireRatingId && filters.ExtFireRatingId._eq) {
        assemblySearchCriteria.assemblyCriteria.ExtFireRatingId = parseInt(filters.ExtFireRatingId._eq.toString());
    } // Wind Uplift and Slope: involve of comparison operators _eq, _gte, and _lte
    // Such criteria in filters has the format like WindUplift: {_eq: "90"} or WindUplift: {_gte: "90"}
    if (filters.WindUplift && filters.WindUplift._eq) {
        assemblySearchCriteria.assemblyCriteria.WindUplift = parseFloat(filters.WindUplift._eq.toString());
        assemblySearchCriteria.assemblyCriteria.WindUpliftOperator = ComparisonOperator.EqualTo;
    }
    else if (filters.WindUplift && filters.WindUplift._gte) {
        assemblySearchCriteria.assemblyCriteria.WindUplift = parseFloat(filters.WindUplift._gte.toString());
        assemblySearchCriteria.assemblyCriteria.WindUpliftOperator = ComparisonOperator.GreaterThanOrEqual;
    }
    else if (filters.WindUplift && filters.WindUplift._lte) {
        assemblySearchCriteria.assemblyCriteria.WindUplift = parseFloat(filters.WindUplift._lte.toString());
        assemblySearchCriteria.assemblyCriteria.WindUpliftOperator = ComparisonOperator.LessThanOrEqual;
    }
    if (filters.Slope && filters.Slope._eq) {
        assemblySearchCriteria.assemblyCriteria.Slope = parseFloat(filters.Slope._eq.toString());
        assemblySearchCriteria.assemblyCriteria.SlopeOperator = ComparisonOperator.EqualTo;
    }
    else if (filters.Slope && filters.Slope._gte) {
        assemblySearchCriteria.assemblyCriteria.Slope = parseFloat(filters.Slope._gte.toString());
        assemblySearchCriteria.assemblyCriteria.SlopeOperator = ComparisonOperator.GreaterThanOrEqual;
    }
    else if (filters.Slope && filters.Slope._lte) {
        assemblySearchCriteria.assemblyCriteria.Slope = parseFloat(filters.Slope._lte.toString());
        assemblySearchCriteria.assemblyCriteria.SlopeOperator = ComparisonOperator.LessThanOrEqual;
    }
    if (filters.PVApplicationMethodId && filters.PVApplicationMethodId._eq) {
        assemblySearchCriteria.assemblyCriteria.PVApplicationMethodId = parseInt(filters.PVApplicationMethodId._eq.toString());
    }
    if (filters.PVHailRatingId && filters.PVHailRatingId._eq) {
        assemblySearchCriteria.assemblyCriteria.PVHailRatingId = parseInt(filters.PVHailRatingId._eq.toString());
    }
    if (filters.IncludesPV && filters.IncludesPV._eq) {
        assemblySearchCriteria.assemblyCriteria.IncludesPV = filters.IncludesPV._eq.toString().toLowerCase() === 'true';
    }
    if (filters.PVWindUplift && filters.PVWindUplift._eq) {
        assemblySearchCriteria.assemblyCriteria.PVWindUplift = parseFloat(filters.PVWindUplift._eq.toString());
        assemblySearchCriteria.assemblyCriteria.PVWindUpliftOperator = ComparisonOperator.EqualTo;
    }
    else if (filters.PVWindUplift && filters.PVWindUplift._gte) {
        assemblySearchCriteria.assemblyCriteria.PVWindUplift = parseFloat(filters.PVWindUplift._gte.toString());
        assemblySearchCriteria.assemblyCriteria.PVWindUpliftOperator = ComparisonOperator.GreaterThanOrEqual;
    }
    else if (filters.PVWindUplift && filters.PVWindUplift._lte) {
        assemblySearchCriteria.assemblyCriteria.PVWindUplift = parseFloat(filters.PVWindUplift._lte.toString());
        assemblySearchCriteria.assemblyCriteria.PVWindUpliftOperator = ComparisonOperator.LessThanOrEqual;
    } // LayerConfigString LIKE '%%' is generated by API code based on layer type ids of layers criteria
    // Populate global search ManufacturerId, ComponentId and LayerTypeId
    // TOCONFIRM: Global products used search should be exclusive to other searches?
    // Current UI implementation: products used search is exclusive to explicitly selected assembly properties? but it can combine with explicitly added roof layers search criteria?
    if (manufacturerProduct && manufacturerProduct.length > 0) {
        for (var i = 0; i < manufacturerProduct.length; i++) {
            if (manufacturerProduct[i].variableId === 'Manufacturer_ManufacturerId')
                assemblySearchCriteria.assemblyCriteria.ManufacturerId = parseInt(manufacturerProduct[i].value);
            else if (manufacturerProduct[i].variableId === 'ManufacturedProduct_ComponentId')
                assemblySearchCriteria.assemblyCriteria.ComponentId = parseInt(manufacturerProduct[i].value);
            else if (manufacturerProduct[i].variableId === 'C_LayerType_LayerTypeId')
                assemblySearchCriteria.assemblyCriteria.LayerTypeId = parseInt(manufacturerProduct[i].value);
        }
    } // Layers Search Criteria
    var _loop_1 = function (i) {
        var layerSearchCriteria = { layerTypeId: 0, approvedUseId: 0, subCategoryId: 0, attributes: [], manufacturerIds: [], componentIds: [], layerNum: 0, fromlayerNum: 0, tolayerNum: 0, selfSecurement: null };
        layerSearchCriteria.layerTypeId = parseInt(layers[i].id);
        layerSearchCriteria.layerNum = i + 1; //Get approvedUseId and subCategoryId (theoretically if there is specific ApprovedUseId, subCategoryId is not necessary for search)
        if (layers[i].isSecurementLayer) { // securement layer
            if (layers[i].variableAssignments) {
                var arrayVariableAssignments = layers[i].variableAssignments;
                layerSearchCriteria.subCategoryId = getSubCategoryId(arrayVariableAssignments, layers[i].section);
                layerSearchCriteria.approvedUseId = getApprovedUseId(arrayVariableAssignments, layers[i].section);
            }
        }
        else { // component layer
            // LayerType 23 - Coating/Surfacing and LayerType 37 - Vapor Retarder may have multiple approved uses.
            if (layerSearchCriteria.layerTypeId === LayerType.Coating_Surfacing_23 || layerSearchCriteria.layerTypeId === LayerType.Vapor_Retarder_37) {
                if (layers[i].variableAssignments) {
                    var arrayVariableAssignments = layers[i].variableAssignments;
                    layerSearchCriteria.subCategoryId = getSubCategoryId(arrayVariableAssignments, layers[i].section);
                    layerSearchCriteria.approvedUseId = layerSearchCriteria.subCategoryId === SpecialSubCategory.Surfacing ? SpecialApprovedUse.Surfacing : getApprovedUseId(arrayVariableAssignments, layers[i].section);
                }
            }
            else { // Get approvedUseId from layer type id and approved use id 1-1 mapping
                // Get subCategoryId from layer type id and subcategory id 1-1 mapping
                var mappedApprovedUseId = COMPONENTLAYERTYPEAPPROVEDUSE_MAP[layerSearchCriteria.layerTypeId];
                layerSearchCriteria.approvedUseId = typeof mappedApprovedUseId !== 'undefined' ? mappedApprovedUseId : 0;
                var mappedSubCategoryId = COMPONENTLAYERTYPESUBCATEGORY_MAP[layerSearchCriteria.layerTypeId];
                layerSearchCriteria.subCategoryId = typeof mappedSubCategoryId !== 'undefined' ? mappedSubCategoryId : 0;
            }
        } //for manufacturer(s) and product(s)
        var manufacturerIds = [];
        var componentIds = [];
        if (layers[i].productDetails) {
            var arrayManufacturerProduct = layers[i].productDetails;
            for (var index = 0; index < arrayManufacturerProduct.length; index++) {
                if (arrayManufacturerProduct[index].productId !== '') { // Product
                    componentIds.push(parseInt(arrayManufacturerProduct[index].productId));
                }
                else if (arrayManufacturerProduct[index].manufacturerId !== '') { // Manufacturer
                    manufacturerIds.push(parseInt(arrayManufacturerProduct[index].manufacturerId));
                }
            }
        }
        layerSearchCriteria.manufacturerIds = manufacturerIds;
        layerSearchCriteria.componentIds = componentIds; // //for attributes filters, reference updateLayerFilter method in src\utils\LayerTypeCheckUtilities.ts
        // //layers[i].variableAssignments and layers[i].section?.variables
        layerSearchCriteria.attributes = getLayerAttributes(layers[i]); // Currently for securementLayer: fromlayerNum and tolayerNum are identifiers of duplicate layers, not layer numbers
        // So, layerSearchCriteria fromLayerNum and toLayerNum have different meaning from securementLayer fromlayerNum and tolayerNum
        // See buildLayerCake function in src\utils\LayerApi.ts   ex. 23,11&40,39{11:22},22,41{22:30-1},30-1,28,30-2,26&51,44{26:35},35
        // const tempSecuremnt = tempFull[1].split(':'); const tempFrom = tempSecuremnt[0].split('-');
        // const fromLayerTypeId = parseInt(tempFrom[0]); const fromLayerNum = parseInt(tempFrom[1]) ?? 1;
        // fromLayerTypeId and toLayerTypeId are the expected values
        if (layers[i].isSecurementLayer) {
            var securementLayer_1 = layers[i]; //if (securementLayer.fromLayerNum) layerSearchCriteria.fromlayerNum = securementLayer.fromLayerNum;
            //if (securementLayer.toLayerNum) layerSearchCriteria.tolayerNum = securementLayer.toLayerNum;
            // get layerSearchCriteria.fromlayerNum
            if (securementLayer_1.fromLayerNum) {
                if (securementLayer_1.fromLayerNum === 1) {
                    layerSearchCriteria.fromlayerNum = layers.findIndex(function (data) { return parseInt(data.id) === securementLayer_1.fromLayerTypeId; }) + 1;
                }
                else if (securementLayer_1.fromLayerNum > 1) {
                    var matched = 0;
                    for (var j = 0; j < layers.length; j++) {
                        if (parseInt(layers[j].id) === securementLayer_1.fromLayerTypeId) {
                            matched++;
                            if (matched === securementLayer_1.fromLayerNum) {
                                layerSearchCriteria.fromlayerNum = j + 1;
                                break;
                            }
                        }
                    }
                }
            } // get layerSearchCriteria.tolayerNum
            if (securementLayer_1.toLayerNum) {
                if (securementLayer_1.toLayerNum === 1) {
                    layerSearchCriteria.tolayerNum = layers.findIndex(function (data) { return parseInt(data.id) === securementLayer_1.toLayerTypeId; }) + 1;
                }
                else if (securementLayer_1.toLayerNum > 1) {
                    var matched = 0;
                    for (var j = 0; j < layers.length; j++) {
                        if (parseInt(layers[j].id) === securementLayer_1.toLayerTypeId) {
                            matched++;
                            if (matched === securementLayer_1.toLayerNum) {
                                layerSearchCriteria.tolayerNum = j + 1;
                                break;
                            }
                        }
                    }
                }
            }
        } // Self-Securement
        if (layers[i].hasSelfSecurement) { // layerSearchCriteria.selfSecurement = {
            //   selfSecurementLayerTypeId: 0,
            //   approvedUseId: 0,
            //   subCategoryId: 0,
            //   attributes: [],
            //   manufacturerIds: [],
            //   componentIds: [],
            //   layerNum: 0,
            // };
            // layerSearchCriteria.selfSecurement.layerNum = i + 1;
            // layerSearchCriteria.selfSecurement.selfSecurementLayerTypeId = parseInt(layers[i].SelfSecurementId as string);
            // //TODO
            // // 1. Consider adding interface ISelfSecurement and SelfSecurement property (object that implements ISelfSecurement) into ILayer.
            // // We need more info on SelfSecurement instead of hasSelfSecurement and SelfSecurementId only.
            // // 2. How to get self-securement Approved Use Id and attributes. Check getLayerAttributes. Can get info from variableAssignments similarly??
            // // 3. Manufacturer and Product on self-securement. Layer itself has productDetails property.
            layerSearchCriteria.selfSecurement = getSelfSecurementSearchCriteria(layers[i], i);
        }
        assemblySearchCriteria.LayerCriteria.push(layerSearchCriteria);
    };
    // TOCHECK: Only consider layers[i].autoSelected === false. It is related to layers join for layer cake search and layerconfig like '%%' in header query
    // Auto polulated manufacturer(s)/product(s) are NOT in productDetails of the layer
    // Auto selected attributes(s) are NOT in variableAssignments of the layer
    // Auto selection(s) on assembly properties are in filters. They are in assemblySearchCriteria.assemblyCriteria based on above Assembly Property Search Criteria assignment.
    for (var i = 0; i < layers.length; i++) {
        _loop_1(i);
    } // excluded layer types
    if (excludedLayerTypeIds && excludedLayerTypeIds.length > 0) {
        assemblySearchCriteria.excludedLayerTypeIds = excludedLayerTypeIds;
    } // Paging and Sorting properties
    assemblySearchCriteria.rowsPerPage = limit;
    assemblySearchCriteria.pageNumber = offset / limit + 1;
    if (orderBy.NavAssemblyName) {
        assemblySearchCriteria.sortColumn = 'NavAssemblyName';
        assemblySearchCriteria.sortDirection = orderBy.NavAssemblyName === Order_By.Asc ? 0 : 1;
    }
    else if (orderBy.AssemblyTypeCode) {
        assemblySearchCriteria.sortColumn = 'AssemblyTypeCode';
        assemblySearchCriteria.sortDirection = orderBy.AssemblyTypeCode === Order_By.Asc ? 0 : 1;
    }
    else if (orderBy.AssemblyApplicationTypeCode) {
        assemblySearchCriteria.sortColumn = 'AssemblyApplicationTypeCode';
        assemblySearchCriteria.sortDirection = orderBy.AssemblyApplicationTypeCode === Order_By.Asc ? 0 : 1;
    }
    else if (orderBy.CoverSecurementMethodCode) {
        assemblySearchCriteria.sortColumn = 'CoverSecurementMethodCode';
        assemblySearchCriteria.sortDirection = orderBy.CoverSecurementMethodCode === Order_By.Asc ? 0 : 1;
    }
    else if (orderBy.DeckTypeCode) {
        assemblySearchCriteria.sortColumn = 'DeckTypeCode';
        assemblySearchCriteria.sortDirection = orderBy.DeckTypeCode === Order_By.Asc ? 0 : 1;
    }
    else if (orderBy.WindUplift || orderBy.WindUpliftValue) {
        assemblySearchCriteria.sortColumn = 'WindUplift';
        if (orderBy.WindUplift)
            assemblySearchCriteria.sortDirection = orderBy.WindUplift === Order_By.Asc ? 0 : 1;
        else
            assemblySearchCriteria.sortDirection = orderBy.WindUpliftValue === Order_By.Asc ? 0 : 1;
    }
    else if (orderBy.IntFireRatingCode) {
        assemblySearchCriteria.sortColumn = 'IntFireRatingCode';
        assemblySearchCriteria.sortDirection = orderBy.IntFireRatingCode === Order_By.Asc ? 0 : 1;
    }
    else if (orderBy.ExtFireRatingCode) {
        assemblySearchCriteria.sortColumn = 'ExtFireRatingCode';
        assemblySearchCriteria.sortDirection = orderBy.ExtFireRatingCode === Order_By.Asc ? 0 : 1;
    }
    else if (orderBy.Slope || orderBy.SlopeValue) {
        assemblySearchCriteria.sortColumn = 'Slope';
        if (orderBy.Slope)
            assemblySearchCriteria.sortDirection = orderBy.Slope === Order_By.Asc ? 0 : 1;
        else
            assemblySearchCriteria.sortDirection = orderBy.SlopeValue === Order_By.Asc ? 0 : 1;
    }
    else if (orderBy.HailRatingCode) {
        assemblySearchCriteria.sortColumn = 'HailRatingCode';
        assemblySearchCriteria.sortDirection = orderBy.HailRatingCode === Order_By.Asc ? 0 : 1;
    }
    else if (orderBy.StatusId) {
        assemblySearchCriteria.sortColumn = 'StatusId';
        assemblySearchCriteria.sortDirection = orderBy.StatusId === Order_By.Asc ? 0 : 1;
    }
    else if (orderBy.LockStatusCode) {
        assemblySearchCriteria.sortColumn = 'LockStatusCode';
        assemblySearchCriteria.sortDirection = orderBy.LockStatusCode === Order_By.Asc ? 0 : 1;
    }
    else {
        assemblySearchCriteria.sortColumn = 'AssemblyNum';
        if (orderBy.AssemblyId)
            assemblySearchCriteria.sortDirection = orderBy.AssemblyId === Order_By.Asc ? 0 : 1;
        else
            assemblySearchCriteria.sortDirection = 0;
    } //console.log("assemblySearchCriteria is ", assemblySearchCriteria);
    return assemblySearchCriteria;
};
var getLayerAttributes = function (layer) {
    var attributes = [];
    if (layer.variableAssignments) {
        var arrayVariableAssignments = layer.variableAssignments;
        var _loop_2 = function (index) {
            var data = arrayVariableAssignments[index];
            var variableAssignmentLabel = (_layer$variableAssign = layer.variableAssignmentLabels) === null || _layer$variableAssign === void 0 ? void 0 : _layer$variableAssign.find(function (obj) { return data.variableId === obj.variableId; });
            if (variableAssignmentLabel) {
                var variableId_1 = variableAssignmentLabel.variableId, type = variableAssignmentLabel.type;
                if (variableId_1 === 'ManufacturerId' || variableId_1 === 'ComponentId' || variableId_1 === 'CApprovedUse_ApprovedUseId' || variableId_1 === 'ManufacturedProduct_CategoryId' || variableId_1 === 'ManufacturedProduct_SubcategoryId' || variableId_1 === 'ExtendedLayerConfigSplit_ExtendedLayerConfigId' || variableId_1 === 'ComponentId_view' || EXCHANGE_VARIABLES.includes("".concat(variableId_1, "_view")) || variableId_1.endsWith('Operator'))
                    return "continue"; // valid attribute search criteria
                var attribute = { attributeName: variableId_1, attributeType: AttributeType.CodeTable, attributeValue: (_data$value = data.value) === null || _data$value === void 0 ? void 0 : _data$value.toString(), comparisonOperator: ComparisonOperator.EqualTo };
                if (type === 'codetable') {
                    attribute.attributeType = AttributeType.CodeTable;
                }
                if (type === 'measurement') {
                    attribute.attributeType = AttributeType.Measurement;
                    var operator = (_layer$variableAssign2 = layer.variableAssignments) === null || _layer$variableAssign2 === void 0 ? void 0 : (_layer$variableAssign3 = _layer$variableAssign2.find(function (data) { return data.variableId === "".concat(variableId_1, "Operator"); })) === null || _layer$variableAssign3 === void 0 ? void 0 : _layer$variableAssign3.value;
                    switch (String(operator)) {
                        case 'Equal':
                            attribute.comparisonOperator = ComparisonOperator.EqualTo;
                            break;
                        case 'BiggerOrEqual':
                            attribute.comparisonOperator = ComparisonOperator.GreaterThanOrEqual;
                            break;
                        case 'LessOrEqual':
                            attribute.comparisonOperator = ComparisonOperator.LessThanOrEqual;
                            break;
                        case 'Bigger':
                            attribute.comparisonOperator = ComparisonOperator.GreaterThan;
                            break;
                        case 'Less':
                            attribute.comparisonOperator = ComparisonOperator.LessThan;
                            break;
                        case 'Different':
                            attribute.comparisonOperator = ComparisonOperator.NotEqualTo;
                            break;
                        default: attribute.comparisonOperator = ComparisonOperator.EqualTo;
                    }
                }
                else if (type === 'boolean') {
                    attribute.attributeValue = Boolean(String(data.value)) ? '1' : '0';
                    attribute.attributeType = AttributeType.Boolean;
                }
                else { //TODO
                }
                attributes.push(attribute);
            }
        };
        var _layer$variableAssign, _data$value, _layer$variableAssign2, _layer$variableAssign3;
        for (var index = 0; index < arrayVariableAssignments.length; index++) {
            _loop_2(index);
        }
    }
    return attributes;
};
var getSelfSecurementSearchCriteria = function (layer, layerIndex) {
    var _layer$selfSecurement, _layer$selfSecurement5;
    var selfSecurementSearchCriteria = { selfSecurementLayerTypeId: layer.SelfSecurementId ? Number(layer.SelfSecurementId) : 0, approvedUseId: 0, subCategoryId: 0, attributes: [], manufacturerIds: [], componentIds: [], layerNum: layerIndex + 1 }; //Get approvedUseId and subCategoryId (theoretically if there is specific ApprovedUseId, subCategoryId is not necessary for search)
    if ((_layer$selfSecurement = layer.selfSecurement) !== null && _layer$selfSecurement !== void 0 && _layer$selfSecurement.variableAssignments) {
        var _layer$selfSecurement2, _layer$selfSecurement3, _layer$selfSecurement4;
        var arrayVariableAssignments = (_layer$selfSecurement2 = layer.selfSecurement) === null || _layer$selfSecurement2 === void 0 ? void 0 : _layer$selfSecurement2.variableAssignments;
        selfSecurementSearchCriteria.subCategoryId = getSubCategoryId(arrayVariableAssignments, (_layer$selfSecurement3 = layer.selfSecurement) === null || _layer$selfSecurement3 === void 0 ? void 0 : _layer$selfSecurement3.section);
        selfSecurementSearchCriteria.approvedUseId = getApprovedUseId(arrayVariableAssignments, (_layer$selfSecurement4 = layer.selfSecurement) === null || _layer$selfSecurement4 === void 0 ? void 0 : _layer$selfSecurement4.section);
    } // for manufacturer(s) and product(s)
    var manufacturerIds = [];
    var componentIds = [];
    if ((_layer$selfSecurement5 = layer.selfSecurement) !== null && _layer$selfSecurement5 !== void 0 && _layer$selfSecurement5.productDetails) {
        var _layer$selfSecurement6;
        var arrayManufacturerProduct = (_layer$selfSecurement6 = layer.selfSecurement) === null || _layer$selfSecurement6 === void 0 ? void 0 : _layer$selfSecurement6.productDetails;
        for (var index = 0; index < arrayManufacturerProduct.length; index++) {
            if (arrayManufacturerProduct[index].productId !== '') { // Product
                componentIds.push(parseInt(arrayManufacturerProduct[index].productId));
            }
            else if (arrayManufacturerProduct[index].manufacturerId !== '') { // Manufacturer
                manufacturerIds.push(parseInt(arrayManufacturerProduct[index].manufacturerId));
            }
        }
    }
    selfSecurementSearchCriteria.manufacturerIds = manufacturerIds;
    selfSecurementSearchCriteria.componentIds = componentIds; // attributes
    selfSecurementSearchCriteria.attributes = getSelfSecurementAttributes(layer.selfSecurement);
    return selfSecurementSearchCriteria;
};
var getSelfSecurementAttributes = function (ssInfo) {
    var attributes = [];
    if (ssInfo.variableAssignments) {
        var arrayVariableAssignments = ssInfo.variableAssignments;
        var _loop_3 = function (index) {
            var data = arrayVariableAssignments[index];
            var variableAssignmentLabel = (_ssInfo$variableAssig = ssInfo.variableAssignmentLabels) === null || _ssInfo$variableAssig === void 0 ? void 0 : _ssInfo$variableAssig.find(function (obj) { return data.variableId === obj.variableId; });
            if (variableAssignmentLabel) {
                var variableId_2 = variableAssignmentLabel.variableId, type = variableAssignmentLabel.type;
                if (variableId_2 === 'ManufacturerId' || variableId_2 === 'ComponentId' || variableId_2 === 'CApprovedUse_ApprovedUseId' || variableId_2 === 'ManufacturedProduct_CategoryId' || variableId_2 === 'ManufacturedProduct_SubcategoryId' || variableId_2 === 'ExtendedLayerConfigSplit_ExtendedLayerConfigId' || variableId_2 === 'ComponentId_view' || EXCHANGE_VARIABLES.includes("".concat(variableId_2, "_view")) || variableId_2.endsWith('Operator'))
                    return "continue"; // valid attribute search criteria
                var attribute = { attributeName: variableId_2, attributeType: AttributeType.CodeTable, attributeValue: (_data$value2 = data.value) === null || _data$value2 === void 0 ? void 0 : _data$value2.toString(), comparisonOperator: ComparisonOperator.EqualTo };
                if (type === 'codetable') {
                    attribute.attributeType = AttributeType.CodeTable;
                }
                if (type === 'measurement') {
                    attribute.attributeType = AttributeType.Measurement;
                    var operator = (_ssInfo$variableAssig2 = ssInfo.variableAssignments) === null || _ssInfo$variableAssig2 === void 0 ? void 0 : (_ssInfo$variableAssig3 = _ssInfo$variableAssig2.find(function (data) { return data.variableId === "".concat(variableId_2, "Operator"); })) === null || _ssInfo$variableAssig3 === void 0 ? void 0 : _ssInfo$variableAssig3.value;
                    switch (String(operator)) {
                        case 'Equal':
                            attribute.comparisonOperator = ComparisonOperator.EqualTo;
                            break;
                        case 'BiggerOrEqual':
                            attribute.comparisonOperator = ComparisonOperator.GreaterThanOrEqual;
                            break;
                        case 'LessOrEqual':
                            attribute.comparisonOperator = ComparisonOperator.LessThanOrEqual;
                            break;
                        case 'Bigger':
                            attribute.comparisonOperator = ComparisonOperator.GreaterThan;
                            break;
                        case 'Less':
                            attribute.comparisonOperator = ComparisonOperator.LessThan;
                            break;
                        case 'Different':
                            attribute.comparisonOperator = ComparisonOperator.NotEqualTo;
                            break;
                        default: attribute.comparisonOperator = ComparisonOperator.EqualTo;
                    }
                }
                else if (type === 'boolean') {
                    attribute.attributeValue = Boolean(String(data.value)) ? '1' : '0';
                    attribute.attributeType = AttributeType.Boolean;
                }
                else { //TODO
                }
                attributes.push(attribute);
            }
        };
        var _ssInfo$variableAssig, _data$value2, _ssInfo$variableAssig2, _ssInfo$variableAssig3;
        for (var index = 0; index < arrayVariableAssignments.length; index++) {
            _loop_3(index);
        }
    }
    return attributes;
};
